import { swRequest } from "@sourcewhale/core";

export const getProject = async (projectId, opts = {}) => {
  // Handle both string and object formats for projectId
  const params = { projectId };

  return swRequest(
    {
      path: "/api/projects/get",
      method: "GET",
      params,
      headers: {},
    },
    opts,
  );
};

export const getAllProjects = (params = {}) =>
  swRequest({
    path: "/api/projects/get_all",
    method: "GET",
    params,
  });

export const getProjectCompanies = () =>
  swRequest({
    path: "/api/projects/get_project_companies",
    method: "GET",
  });

export const getProjectReports = (body) =>
  swRequest({
    path: "/api/projects/get_project_reports",
    method: "POST",
    body,
  });

export const saveProject = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/projects/save",
      method: "POST",
      body,
    },
    opts,
  );

export const modifyProject = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/projects/modify",
      method: "POST",
      body,
    },
    opts,
  );

export const aiRewriteJobDescription = (jobDescription) =>
  swRequest({
    path: "/api/projects/ai_rewrite",
    method: "POST",
    body: { jobDescription },
  });

export const associateToProject = (body) =>
  swRequest({
    path: "/api/projects/associate",
    method: "POST",
    body,
  });

export const changeTypeProject = (body) =>
  swRequest({
    path: "/api/projects/change_type",
    method: "POST",
    body,
  });

export const savePipelineTemplate = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/projects/save_template",
      method: "POST",
      body,
    },
    opts,
  );

export const updatePipelineTemplate = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/projects/update_template",
      method: "POST",
      body,
    },
    opts,
  );

export const getPipelineTemplates = (opts = {}) =>
  swRequest({ path: "/api/projects/get_templates", method: "GET" }, opts);
